export default class ShowMore
{
  constructor(debug = false) {

    this.debug = debug;
    if (this.debug) console.log('ShowMore init');

    if (!this.setVars()) return;
    if (this.debug) console.log('ShowMore vars init done');

    this.setEvents();
    this.calcItemsMaxHeights();
    this.showMorePosts(this.INITIAL_COUNT);
    this.updateShowMoreVisibiliy();
  }

  setVars()
  {
    this.showMoreSection = document.querySelector('[data-show-more]');
    if (!this.showMoreSection) return;

    this.showMoreButton = this.showMoreSection.querySelector('[data-show-more="button"]');
    if (!this.showMoreButton) return;

    this.posts = this.showMoreSection.querySelectorAll('[data-show-more="post"]');
    if (!this.posts.length) return;

    this.postsVisible = 0;
    this.postCount    = this.posts.length;
    this.maxHeight    = 0;

    this.INITIAL_COUNT = 3;
    this.MORE_COUNT    = 3;
    this.MARGIN_BOTTOM = 30;

    return true;
  }


  setEvents()
  {
    this.showMoreButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.onButtonClick();
    });
  }


  onButtonClick()
  {
    this.showMorePosts(this.postsVisible + this.MORE_COUNT);
  }


  calcItemsMaxHeights()
  {
    for (let i = 0; i < this.postCount; i++)
    {
      this.posts[i].classList.remove('hidden');
      const { height } = this.posts[i].getBoundingClientRect();
      this.maxHeight = Math.max(this.maxHeight, height + this.MARGIN_BOTTOM);
      this.posts[i].classList.add('hidden');
    }
  }


  showMorePosts(number)
  {
    for (let i = 0; i < Math.min(this.postCount, number); i++)
    {
      this.posts[i].classList.add('transition');
      this.posts[i].style.maxHeight = `${this.maxHeight}px`;

      if (this.posts[i].classList.contains('hidden')) {
        this.posts[i].classList.remove('hidden');
        this.postsVisible++;
      }
    }

    this.updateShowMoreVisibiliy();
  }


  updateShowMoreVisibiliy()
  {
    if (this.postCount <= this.postsVisible) {
      this.showMoreButton.classList.add('hidden');
    }
  }
}
